"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jwt_decode_1 = __importDefault(require("jwt-decode"));
var lodash_1 = require("lodash");
var moment_1 = __importDefault(require("moment"));
var query_string_1 = __importDefault(require("query-string"));
var uuid_1 = require("uuid");
var __1 = require("../");
var Config_1 = require("../../Config");
var constants_1 = require("../../constants");
var ConnectedModel_1 = require("../../utils/ConnectedModel");
var hydrate_1 = require("../../utils/persistance/hydrate");
var persist_1 = require("../../utils/persistance/persist");
var AUTH_VALUES;
(function (AUTH_VALUES) {
    AUTH_VALUES["API_KEY"] = "apiKey";
    AUTH_VALUES["EXPIRATION"] = "expiration";
    AUTH_VALUES["ACCESS_TOKEN"] = "accessToken";
    AUTH_VALUES["ID_TOKEN"] = "idToken";
    AUTH_VALUES["REFRESH_TOKEN"] = "refreshToken";
    AUTH_VALUES["STATE"] = "state";
})(AUTH_VALUES = exports.AUTH_VALUES || (exports.AUTH_VALUES = {}));
var Auth = /** @class */ (function (_super) {
    __extends(Auth, _super);
    function Auth() {
        var _this = _super.call(this, '/auth') || this;
        _this.requestMagickLink = function (phoneNumber, metaData) {
            return _this.makeRequest('/auth/functions/request-magic-link', ConnectedModel_1.METHOD.POST, {
                meta_data: metaData,
                phone_number: phoneNumber,
            });
        };
        _this.verifyMagickLink = function (params, phoneNumber, answer) { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest('/auth/functions/verify-magic-link', ConnectedModel_1.METHOD.POST, {
                            answer: answer,
                            phone_number: phoneNumber,
                            session: params.Session,
                        })];
                    case 1:
                        result = _a.sent();
                        return [4 /*yield*/, Config_1.config.emitExtension('onAuthenticated', result.AuthenticationResult)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.storeCredentials(result.AuthenticationResult)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, this.returnWithGroups(result.AuthenticationResult)];
                }
            });
        }); };
        _this.returnWithGroups = function (result) { return __awaiter(_this, void 0, void 0, function () {
            var groups, _a, driver, subcontractor;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getGroups()];
                    case 1:
                        groups = _b.sent();
                        return [4 /*yield*/, Promise.all([
                                groups.includes('driver') && this.fetchDriverForUser(),
                                groups.includes('subco') && this.fetchSubcoForUser(),
                            ].filter(Boolean))];
                    case 2:
                        _a = _b.sent(), driver = _a[0], subcontractor = _a[1];
                        return [2 /*return*/, __assign({}, result, { driver: driver, subcontractor: subcontractor })];
                }
            });
        }); };
        _this.storeCredentials = function (credentials, invalidate) {
            if (invalidate === void 0) { invalidate = true; }
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!invalidate) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.invalidate()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [4 /*yield*/, Promise.all([
                                this.setValue(AUTH_VALUES.EXPIRATION, moment_1.default().add(credentials.ExpiresIn, 'seconds').toISOString()),
                                this.setValue(AUTH_VALUES.ACCESS_TOKEN, credentials.AccessToken),
                                this.setValue(AUTH_VALUES.ID_TOKEN, credentials.IdToken),
                                credentials.RefreshToken
                                    ? this.setValue(AUTH_VALUES.REFRESH_TOKEN, credentials.RefreshToken)
                                    : Promise.resolve(),
                            ])];
                        case 3:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        _this.storeTokenSet = function (accessToken, refreshToken) { return __awaiter(_this, void 0, void 0, function () {
            var exp, expiration;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        exp = jwt_decode_1.default(accessToken).exp;
                        expiration = moment_1.default.unix(exp).toISOString();
                        return [4 /*yield*/, Promise.all([
                                this.setValue(AUTH_VALUES.EXPIRATION, expiration),
                                this.setValue(AUTH_VALUES.ACCESS_TOKEN, accessToken),
                                refreshToken && this.setValue(AUTH_VALUES.REFRESH_TOKEN, refreshToken),
                            ].filter(Boolean))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.refreshAccessToken = function () { return __awaiter(_this, void 0, void 0, function () {
            var refreshToken, isExtensionUsed, _a, _b, result;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.getValue(AUTH_VALUES.REFRESH_TOKEN)];
                    case 1:
                        refreshToken = _c.sent();
                        if (!refreshToken) {
                            throw new Error('No refresh token found');
                        }
                        return [4 /*yield*/, this.isExpired()];
                    case 2:
                        if (!_c.sent()) return [3 /*break*/, 8];
                        return [4 /*yield*/, Config_1.config.emitExtension('onTokenRenegotiation')];
                    case 3:
                        isExtensionUsed = _c.sent();
                        if (!isExtensionUsed) return [3 /*break*/, 5];
                        _a = this.returnWithGroups;
                        _b = {};
                        return [4 /*yield*/, this.getValue(AUTH_VALUES.ACCESS_TOKEN)];
                    case 4: return [2 /*return*/, _a.apply(this, [(_b.AccessToken = _c.sent(),
                                _b)])];
                    case 5: return [4 /*yield*/, this.makeRequest('/auth/functions/refresh-credentials', ConnectedModel_1.METHOD.POST, {
                            refresh_token: refreshToken,
                        })];
                    case 6:
                        result = _c.sent();
                        return [4 /*yield*/, this.storeCredentials(result.AuthenticationResult, false)];
                    case 7:
                        _c.sent();
                        return [2 /*return*/, this.returnWithGroups(result.AuthenticationResult)];
                    case 8: return [2 /*return*/, true];
                }
            });
        }); };
        _this.initiateGoogleLogin = function (redirectUri) { return __awaiter(_this, void 0, void 0, function () {
            var state, params, endpoint;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        state = uuid_1.v4();
                        return [4 /*yield*/, this.setValue(AUTH_VALUES.STATE, state)];
                    case 1:
                        _a.sent();
                        params = {
                            client_id: this.getCognitoClientId(),
                            identity_provider: "Google",
                            redirect_uri: redirectUri,
                            response_type: "code",
                            scope: "openid phone email profile",
                            state: state,
                        };
                        endpoint = this.getCognitoURL();
                        window.location.href = endpoint + "?" + query_string_1.default.stringify(params);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.completeGoogleLogin = function (state, redirectUri, code) { return __awaiter(_this, void 0, void 0, function () {
            var _a, result, tokenResult;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = state;
                        return [4 /*yield*/, this.getValue(AUTH_VALUES.STATE)];
                    case 1:
                        if (_a !== (_b.sent())) {
                            throw new Error("Invalid state returned by Google. This could indicate login forgery.");
                        }
                        return [4 /*yield*/, this.makeRequest("/auth/functions/get-credentials-for-google-code", ConnectedModel_1.METHOD.GET, {
                                code: code,
                                redirect_uri: redirectUri,
                            })];
                    case 2:
                        result = _b.sent();
                        tokenResult = {
                            AccessToken: result.access_token,
                            ExpiresIn: result.expires_in,
                            IdToken: result.id_token,
                            RefreshToken: result.refresh_token,
                        };
                        return [4 /*yield*/, Config_1.config.emitExtension('onAuthenticated', tokenResult)];
                    case 3:
                        _b.sent();
                        return [4 /*yield*/, this.storeCredentials(tokenResult)];
                    case 4:
                        _b.sent();
                        return [2 /*return*/, this.returnWithGroups(result)];
                }
            });
        }); };
        _this.fetchSubcoForUser = function () { return __awaiter(_this, void 0, void 0, function () {
            var subcontractors, _a, _b, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 3, , 4]);
                        _a = this.makeRequest;
                        _b = ["/auth/functions/fetch-subcontractor-for-user",
                            ConnectedModel_1.METHOD.GET,
                            {}];
                        return [4 /*yield*/, this.getValue(AUTH_VALUES.ACCESS_TOKEN)];
                    case 1: return [4 /*yield*/, _a.apply(this, _b.concat([_c.sent()]))];
                    case 2:
                        subcontractors = _c.sent();
                        if (subcontractors.length) {
                            return [2 /*return*/, subcontractors.map(function (subcontractor) { return new __1.Subco(subcontractor.id, subcontractor.name, subcontractor.location.id, subcontractor.active, subcontractor.tag, subcontractor.defaultStartTime, subcontractor.defaultDayStartTime, subcontractor.inventoryScanCompletedAt); })];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _c.sent();
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/, null];
                }
            });
        }); };
        _this.fetchDriverForUser = function () { return __awaiter(_this, void 0, void 0, function () {
            var driver, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.makeRequest;
                        _b = ['/auth/functions/fetch-driver-for-user',
                            ConnectedModel_1.METHOD.GET,
                            {}];
                        return [4 /*yield*/, this.getValue(AUTH_VALUES.ACCESS_TOKEN)];
                    case 1: return [4 /*yield*/, _a.apply(this, _b.concat([_c.sent()]))];
                    case 2:
                        driver = _c.sent();
                        if (!driver) {
                            throw new Error('No driver found?');
                        }
                        return [2 /*return*/, new __1.Driver(driver.id, driver.name, driver.emailAddress, driver.phoneNumber, driver.picture, driver.subco_id, driver.active)];
                }
            });
        }); };
        _this.isExpired = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, expiration, token;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.getValue(AUTH_VALUES.EXPIRATION),
                            this.getValue(AUTH_VALUES.ACCESS_TOKEN),
                        ])];
                    case 1:
                        _a = _b.sent(), expiration = _a[0], token = _a[1];
                        return [2 /*return*/, !expiration
                                || !token
                                || moment_1.default().add(Auth.TOKEN_MARGIN_SECONDS, 'seconds').isAfter(moment_1.default(expiration))];
                }
            });
        }); };
        _this.getToken = function () { return __awaiter(_this, void 0, void 0, function () {
            var hasAccess;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkAccess()];
                    case 1:
                        hasAccess = _a.sent();
                        return [2 /*return*/, hasAccess
                                ? this.getValue(AUTH_VALUES.ACCESS_TOKEN)
                                : null];
                }
            });
        }); };
        _this.checkAccess = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isExpired()];
                    case 1:
                        if (!_a.sent()) return [3 /*break*/, 5];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.refreshAccessToken()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 4:
                        error_1 = _a.sent();
                        return [2 /*return*/, false];
                    case 5: return [2 /*return*/, true];
                }
            });
        }); };
        _this.getGroups = function () { return __awaiter(_this, void 0, void 0, function () {
            var accessToken, decode;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getValue(AUTH_VALUES.ACCESS_TOKEN)];
                    case 1:
                        accessToken = _a.sent();
                        if (accessToken) {
                            decode = jwt_decode_1.default(accessToken);
                            return [2 /*return*/, lodash_1.get(decode, 'cognito:groups', [])];
                        }
                        return [2 /*return*/, []];
                }
            });
        }); };
        _this.isSubco = function () { return __awaiter(_this, void 0, void 0, function () {
            var groups;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getGroups()];
                    case 1:
                        groups = _a.sent();
                        return [2 /*return*/, groups.includes(constants_1.Roles.SUBCO)];
                }
            });
        }); };
        _this.isPlanner = function () { return __awaiter(_this, void 0, void 0, function () {
            var groups;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getGroups()];
                    case 1:
                        groups = _a.sent();
                        return [2 /*return*/, groups.includes(constants_1.Roles.PLANNER)];
                }
            });
        }); };
        _this.isDriver = function () { return __awaiter(_this, void 0, void 0, function () {
            var groups;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getGroups()];
                    case 1:
                        groups = _a.sent();
                        return [2 /*return*/, groups.includes(constants_1.Roles.DRIVER)];
                }
            });
        }); };
        _this.isCustomerService = function () { return __awaiter(_this, void 0, void 0, function () {
            var groups;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getGroups()];
                    case 1:
                        groups = _a.sent();
                        return [2 /*return*/, groups.includes(constants_1.Roles.CUSTOMER_SERVICE)];
                }
            });
        }); };
        _this.getUserSub = function () { return __awaiter(_this, void 0, void 0, function () {
            var accessToken, decode;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getValue(AUTH_VALUES.ACCESS_TOKEN)];
                    case 1:
                        accessToken = _a.sent();
                        if (accessToken) {
                            decode = jwt_decode_1.default(accessToken);
                            return [2 /*return*/, lodash_1.get(decode, 'sub', '')];
                        }
                        return [2 /*return*/, ''];
                }
            });
        }); };
        _this.invalidate = function () {
            return Promise.all([
                _this.setValue(AUTH_VALUES.EXPIRATION, undefined),
                _this.setValue(AUTH_VALUES.ACCESS_TOKEN, undefined),
                _this.setValue(AUTH_VALUES.REFRESH_TOKEN, undefined),
                _this.setValue(AUTH_VALUES.ID_TOKEN, undefined),
            ]);
        };
        _this.getCognitoURL = function () {
            switch (Config_1.config.getOption('mode')) {
                case Config_1.MODE.DEVELOPMENT:
                    return "https://trunkrs-authentication-dev.auth.eu-west-1.amazoncognito.com/oauth2/authorize";
                case Config_1.MODE.QA:
                case Config_1.MODE.PRODUCTION:
                    return "https://trunkrs-authentication-prod.auth.eu-west-1.amazoncognito.com/oauth2/authorize";
                default:
                    return "";
            }
        };
        _this.getCognitoClientId = function () {
            switch (Config_1.config.getOption('mode')) {
                case Config_1.MODE.DEVELOPMENT:
                    return "20daf48nanntlf145f5jn1e92s";
                case Config_1.MODE.QA:
                case Config_1.MODE.PRODUCTION:
                    return "3d9sufecdr6u1s80c63ro7mita";
                default:
                    return "20daf48nanntlf145f5jn1e92s";
            }
        };
        return _this;
    }
    Auth.prototype.setValue = function (key, value) {
        this[key] = value;
        return Promise.resolve(this[key]);
    };
    Auth.prototype.getValue = function (key) {
        return Promise.resolve(this[key]);
    };
    Auth.TOKEN_MARGIN_SECONDS = 5 * 60;
    __decorate([
        persist_1.persist,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Object]),
        __metadata("design:returntype", Promise)
    ], Auth.prototype, "setValue", null);
    __decorate([
        hydrate_1.hydrate,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], Auth.prototype, "getValue", null);
    return Auth;
}(ConnectedModel_1.ConnectedModel));
exports.Auth = Auth;
